/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'putVG3ux4WkaAxfWDu1R3w.png': { uri: '/images/putVG3ux4WkaAxfWDu1R3w.png' }
}

export default imageStaticSourcesByFileName
